
import { defineComponent } from "vue";

export default defineComponent({
  name: "Error State",
  setup() {
    return {};
  },
});
